import React from 'react';
import { Github, Linkedin, Code2, BarChart3, LucideIcon } from 'lucide-react';
import { socialLinks } from '../data/about';

const iconMap: Record<string, LucideIcon> = { Github, Linkedin, Code2, BarChart3 };

interface SocialLinksProps {
  size?: number;
  className?: string;
}

const SocialLinks: React.FC<SocialLinksProps> = ({ size = 20, className = '' }) => {
  return (
    <div className={`flex gap-3 ${className}`}>
      {socialLinks.map(({ iconName, href, label }) => {
        const Icon = iconMap[iconName];
        return (
          <a
            key={label}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            title={label}
            className="p-3 rounded-lg border border-white/10 text-gray-400 hover:text-accent hover:border-accent/50 hover:shadow-neon transition-all duration-300"
          >
            <Icon size={size} />
          </a>
        );
      })}
    </div>
  );
};

export default SocialLinks;
